export default __webpack_public_path__ + "static/self-checkout-e168219c1956d4c4b3fc38ca5e6cda44.jpg";